<div class="search-subscription-overlay" 
     cdkTrapFocus 
     cdkTrapFocusAutoCapture
 >
  <button class="search-subscription-overlay__close"
          (click)="close()"
  >
    <i class="search-subscription-overlay__close-icon material-icon material-icon--outlined">
      close
    </i>
  </button>

  <div class="search-subscription-overlay__top-bar"
       *ngIf="!wasSuccessful"
  >
    <h2 class="search-subscription-overlay__title">
      {{ 'searchSubscription.overlay.title' | i18n }}
    </h2>
  </div>

  <div class="search-subscription-overlay__main"
       cdkScrollable
       *ngIf="!wasSuccessful"
  >
    <p class="search-subscription-overlay__text">
      {{ 'searchSubscription.overlay.text' | i18n }}
    </p>

    <div class="search-subscription-overlay__chips">
      <lib-filter-chips>
        <div class="search-subscription-overlay__modify-filter search-subscription-overlay__modify-filter--mobile">
          <button class="change-filter-button"
                  (click)="goToMobileFilters($event)"
          >
            {{ 'searchSubscription.overlay.changeFilter.mobile.button' | i18n }}
          </button>

          <i class="material-icon material-icon--outlined modify-filter-icon">edit</i>
        </div>

        <div class="search-subscription-overlay__modify-filter search-subscription-overlay__modify-filter--desktop">
          {{ 'searchSubscription.overlay.changeFilter.desktop.part1' | i18n }}
          {{ 'searchSubscription.overlay.changeFilter.desktop.button' | i18n }}
          {{ 'searchSubscription.overlay.changeFilter.desktop.part2' | i18n }}

          <i class="material-icon material-icon--outlined modify-filter-icon">edit</i>
        </div>
      </lib-filter-chips>
    </div>

    <div class="search-subscription-overlay__form">
      <lib-search-subscription-form></lib-search-subscription-form>

      <p class="search-subscription-overlay__legal_notes caption caption--grey"
         [innerHTML]="'searchSubscription.form.thirdPartyHint' | i18n"
      ></p>
    </div>
  </div>

  <div class="search-subscription-overlay__apply-button"
       *ngIf="!wasSuccessful"
  >
    <button class="mdc-button filter-apply-button"
            [disabled]="!canSubmit ? true : null"
            (click)="saveSearchSubscription()"
    >
      <span class="mdc-button__ripple"></span>
      <span class="mdc-button__label">
        {{ 'searchSubscription.save' | i18n }}
      </span>
      <span class="mdc-button__touch"></span>
    </button>
  </div>

  <div class="search-subscription-overlay__success-message"
       *ngIf="wasSuccessful"
  >
    <lib-success-message>
      <button class="mdc-button success-message__button"
              (click)="close()"
      >
        <span class="mdc-button__ripple"></span>
        <span class="mdc-button__label">
          {{ 'searchSubscription.overlay.showResults' | i18n }}
        </span>
        <span class="mdc-button__touch"></span>
      </button>
    </lib-success-message>
  </div>
</div>
